// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_gX","advertDetailContactGroup__header":"c-l_gY","advertDetailContactGroup__value":"c-l_gZ"};